import React, { useEffect, useState } from 'react';
import { Button, Card, Modal, notification, Space, Tooltip, Typography, Upload } from 'antd';
import 'react-phone-input-2/lib/style.css';
import { DocumentProps, FileProps } from "../../types/types";
import { DeleteOutlined, PlusOutlined, QuestionCircleFilled } from '@ant-design/icons';
import { useDocuments } from "../../context/documents.context";
import Cookies from "universal-cookie";


const { Title, Text } = Typography;

export const AdditionalDocuments: React.FC<{ listOfDocuments: DocumentProps[] }> = ( props ) => {
  const { listOfDocuments } = props;

  const { uploadDocument, setDocumentLoading, getDocumentsByType, deleteDocument, getDocuments } = useDocuments();
  const [listOfRequiredDocuments, setListOfRequiredDocuments] = useState<FileProps[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [documentToDelete, setDocumentToDelete] = useState('');
  const [allDocuments, setAllDocuments] = useState<DocumentProps[]>([]);

  const cookies = new Cookies();
  const companyId = cookies.get('companyId');

  useEffect(() => {
    setAllDocuments(listOfDocuments);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const ListOfDocument: FileProps[] = [];
    allDocuments.map(( document: DocumentProps ) => {
      if (document.uploaded) {
        getDocumentsByType.execute(companyId, document.type)
          .then(( data ) => {
            //console.log(data);
          })
          .catch(() => {
            ListOfDocument.push(new FileProps(document.type, null));
          });
      } else {
        ListOfDocument.push(new FileProps(document.type, null));
      }
      return ListOfDocument;
    });
    setListOfRequiredDocuments(ListOfDocument);
  }, [allDocuments]); // eslint-disable-line react-hooks/exhaustive-deps

  function onRefresh() {
    getDocuments.execute(companyId).then(( data ) => {
      const listOfRequiredDocuments = data.documents?.filter(( document: DocumentProps ) => !document.required)
      setAllDocuments(listOfRequiredDocuments);
    }).catch(() => {
      setAllDocuments([]);
    });
  }

  function deleteDocumentByType( documentType: string ) {
    deleteDocument.execute(cookies.get('companyId'), documentType)
      .then(() => {
        onRefresh();
        notification.success({
          message: 'Document deleted successfully',
        });
      })
      .catch(() => {
        notification.error({
          message: 'Document delete failed',
        });
      })
      .finally(() => {
        setDocumentLoading(false);
      });
  }

  function getName( document: DocumentProps ) {
    if (document?.type.match(/_/)) {
      return document?.type.replace(/(_)/g, ' ');
    }
    return document?.type.replace(/([A-Z])/g, ' $1');
  }


  const handleOk = () => {
    setDocumentLoading(true);
    deleteDocumentByType(documentToDelete);
    setIsModalOpen(false);
    setDocumentToDelete('');
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setDocumentToDelete('');
  };

  function onDelete( document: DocumentProps ) {
    setIsModalOpen(true);
    setDocumentToDelete(document?.type);
  }

  return (
    <Space direction={'vertical'} size={'small'} className={'full-width'}>

      {allDocuments.map(( document: DocumentProps, index: number ) => {
        return (

          <Card style={{ padding: '20px', borderRadius: '6px' }} className={'full-width'} key={document.type}>
            <Space direction={'vertical'} size={'small'} className={'full-width'}>


              <Space direction={'horizontal'} className={'ant-row-space-between'} style={{ width: '100%' }}>

                <Space.Compact direction={'vertical'}>
                  <Space direction={'horizontal'} size={'small'} className={'ant-row-space-around'}>
                    <Title style={{ margin: 0 }} level={5}>
                      {getName(document)}
                    </Title>
                    <Tooltip placement="top" title={'tooltip'}>
                      <QuestionCircleFilled style={{ fontSize: '18px' }}/>
                    </Tooltip>
                  </Space>

                  {document?.uploaded ?
                    <Text type="success">Uploaded</Text>
                    : <Text type="secondary">Not Uploaded</Text>
                  }
                </Space.Compact>

                {document?.uploaded && listOfRequiredDocuments.filter(( doc ) => doc.type === document.type) !== null ? (
                    <Button type="primary" shape="circle"
                            icon={<DeleteOutlined onClick={() => onDelete(document)}
                                                  style={{ cursor: 'pointer', fontSize: '14px' }}/>}
                            size="large"
                            style={{ backgroundColor: '#56565614', borderColor: '#FFFFFF' }}/>

                  ) :
                  (
                    <Upload
                      name="avatar"
                      className="avatar-uploader"
                      showUploadList={false}
                      beforeUpload={( file ) => {

                        setDocumentLoading(true);
                        uploadDocument
                          .execute(
                            companyId,
                            file,
                            document?.type,
                          )
                          .then(function () {
                            onRefresh();
                            notification.success({
                              message: 'Document uploaded successfully',
                            });
                          })
                          .catch(function () {
                            notification.error({
                              message: 'Document upload failed',
                            });
                          })
                          .finally(() => {
                            setDocumentLoading(false);
                          });
                          return false;
                      }
                      }
                    >
                      <Button type="primary" shape="circle"
                              icon={<PlusOutlined style={{ cursor: 'pointer', fontSize: '20px' }}/>}
                              size="large"
                              style={{ backgroundColor: '#56565614', borderColor: '#FFFFFF' }}/>
                    </Upload>
                  )
                }
              </Space>
            </Space>
          </Card>
        )
      })}
      <Modal title="Delete Confirmation" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} okText={'Delete'}>
        <p>Are you sure you want to delete the document?</p>
      </Modal>
    </Space>
  );
};
